module.exports = __webpack_public_path__ + "static/media/file-blue.e4dac59a.svg";